<template>
	<div class="inline-column-between basic-layout-v">
		<top-menu />
		<div class="main-container">
			<keep-alive>ß
			  <router-view />
			</keep-alive>
		</div>
		<!-- <channel-list /> -->
	</div>
</template>

<script>
	import TopMenu from '@/components/controlsV/TopMenu.vue';
	import ChannelList from '@/components/controlsV/ChannelList.vue';
	export default {
		name: 'BasicLayoutH',
		components: {
			TopMenu,
			ChannelList
		},
		data() {
			return {
				
			}
		},
	}
</script>

<style scoped lang="less">
	.basic-layout-v {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		
		//background-image: url("../../assets/page-sample.jpg");
		//background-size: 100%;
		//background-repeat: no-repeat;
	}
	.main-container {
		width: 100%;
		//padding: calc(58px * var(--scale-rate)) calc(160px * var(--scale-rate)) 0 0;
		flex: 1;
		overflow-y: auto;
		overflow-x: hidden;
	}
</style>